<div class="toast" [class]="'toast toast--' + data.type">

  <div class="toast__body">

    <!-- Círculo con icono según tipo -->
    <div class="toast__badge">
      <mat-icon>{{ icon }}</mat-icon>
    </div>

    <!-- Texto: título + mensaje -->
    <div class="toast__text">
      <span class="toast__title">{{ data.title }}</span>
      <span class="toast__message">{{ data.message }}</span>
    </div>

    <!-- Botón cerrar — esquina superior derecha del body -->
    <button class="toast__close" type="button" (click)="dismiss()" aria-label="Cerrar notificación">
      <span class="toast__close-x" aria-hidden="true">&times;</span>
    </button>

  </div>

  <!-- Barra de progreso pegada al fondo -->
  <div class="toast__track">
    <div class="toast__bar" [style.width.%]="progress"></div>
  </div>

</div>
